import { AttachmentView, MessageView } from '../core/hub-types';

export type CopyContent = { kind: 'text'; text: string } | { kind: 'image'; attachment: AttachmentView };

/** What "Copy" on a message takes: its text, or for a message that is only a picture, the picture. */
export function copyContent(m: Pick<MessageView, 'body' | 'deletedAt' | 'attachments'>): CopyContent | null {
  if (m.deletedAt) return null;
  if (m.body?.trim()) return { kind: 'text', text: m.body };
  const image = (m.attachments ?? []).find((a) => a.contentType.startsWith('image/'));
  return image ? { kind: 'image', attachment: image } : null;
}

/**
 * A pasted file's name. A screenshot arrives as "image.png" (or with no name), so it is named after when it was pasted;
 * a real file keeps its own.
 */
export function pastedFileName(file: File, index: number, now: Date): string {
  if (file.name && file.name !== 'image.png') return file.name;
  const pad = (n: number) => String(n).padStart(2, '0');
  const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
  const ext = (file.type.split('/')[1] ?? 'png').replace('jpeg', 'jpg');
  return `pasted-${stamp}${index ? `-${index}` : ''}.${ext}`;
}
